// We keep the old tracking category for backward compatibility, before aligning on a date when we start using the new one
export const TRACKING_CATEGORY = 'dealer locator';
